import DashboardConnector from './DashboardConnector';

export default DashboardConnector;
